<script>
    import { apiUrl } from "@/utils";
    import TheSlider from "@main/packages/TheSlider";
    import BaseButton from "@main/packages/BaseButton";
    import TheSvgIcon from "@main/packages/TheSvgIcon";
    import RecipeDetailIngredients from "@miku-kz/components/recipes/RecipeDetailIngredients";

    export default {
        name: "RecipeDetailCard",
        components: { TheSlider, BaseButton, TheSvgIcon, RecipeDetailIngredients },
        props: {
            recipe: Object,
        },
        data() {
            return {
                slider: null,
            };
        },
        computed: {
            hasIngredients() {
                return this.recipe?.ingredients ? this.recipe.ingredients[0]?.value : false;
            },
        },
        methods: {
            apiUrl,
            openModalVideo() {
                this.$popup.show("modal-video", {
                    videoId: this.recipe.video,
                    autoplay: true,
                });
            },
        },
    };
</script>

<template>
    <div class="recipe-detail-card recipe-detail__section">
        <div class="recipe-detail-card__title desktop-hidden">{{ recipe.name }}</div>
        <div class="recipe-detail-card__inner">
            <div class="recipe-detail-card__images">
                <the-slider
                    name-slider="recipe-detail-card"
                    :list="recipe.images"
                    :is-bullets="true"
                    :bullets-options="{ dynamicBullets: true }"
                >
                    <div
                        slot="swiper-slide"
                        v-for="(image, index) in recipe.images"
                        :key="index"
                        class="swiper-slide recipe-detail-card__image"
                    >
                        <img :src="apiUrl(image)" alt="" />
                    </div>
                </the-slider>
            </div>
            <div class="recipe-detail-card__info">
                <div class="recipe-detail-card__title mobile-hidden">{{ recipe.name }}</div>

                <div class="recipe-detail-card__specs">
                    <div v-if="recipe.preparingTime" class="recipe-detail-card__spec">
                        <the-svg-icon name="time"></the-svg-icon>
                        {{ recipe.preparingTime }}
                    </div>
                    <div v-if="recipe.power" class="recipe-detail-card__spec">
                        <the-svg-icon name="power"></the-svg-icon>
                        {{ recipe.power }}
                    </div>
                </div>

                <div v-if="hasIngredients" class="recipe-detail-card__subtitle">
                    Ингредиенты
                </div>

                <div v-if="hasIngredients" class="recipe-detail-card__ingredients">
                    <recipe-detail-ingredients
                        :ingredients="recipe.ingredients"
                    ></recipe-detail-ingredients>
                </div>

                <base-button
                    v-if="recipe.video"
                    class="recipe-detail-card__button"
                    size="md"
                    @click="openModalVideo"
                >
                    Смотреть видео
                </base-button>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .recipe-detail-card {
        padding: 24px 16px 16px;
        @include bp($bp-desktop-sm) {
            padding: 40px 40px 48px;
        }
    }

    .recipe-detail-card__title {
        margin-bottom: 16px;
        color: #0b0b0b;
        font-size: 18px;
        font-weight: 700;
        line-height: 22px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 12px;
            font-size: 28px;
            line-height: 36px;
            letter-spacing: -0.01em;
        }
    }

    .recipe-detail-card__subtitle {
        margin-bottom: 16px;
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 12px;
            font-size: 18px;
            font-weight: 500;
            line-height: 22px;
        }
    }

    .recipe-detail-card__inner {
        @include bp($bp-desktop-sm) {
            display: flex;
        }
    }

    .recipe-detail-card__images {
        position: relative;
        margin-bottom: 16px;
        border-radius: 15px;
        overflow: hidden;
        .c-slider__swiper {
            margin-bottom: 0;
        }
        .c-slider__bottom-wrapper {
            margin-top: 16px;
        }
        .c-slider__arrow {
            transition: 0.3s ease-in-out all;
            display: none;
            width: 44px;
            height: 44px;
            background-color: rgba(#000, 0.3);
            &:hover {
                background-color: rgba(#000, 0.5);
            }
            @include bp($bp-desktop-sm) {
                display: flex;
            }
        }
        @include bp($bp-desktop-sm) {
            flex-shrink: 0;
            flex-basis: 690px;
            max-width: 690px;
            margin-right: 40px;
            margin-bottom: 0;
            border-radius: 25px;
            .c-slider__bottom-wrapper {
                display: none;
            }
        }
    }

    .recipe-detail-card__image {
        @include responsive-box(66.66%);
        img {
            @include center-absolute(0);
            border-radius: 15px;
            @include bp($bp-desktop-sm) {
                border-radius: 25px;
            }
        }
    }

    .recipe-detail-card__info {
        @include bp($bp-desktop-sm) {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            max-height: 460px;
        }
    }

    .recipe-detail-card__specs {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 24px;
        }
    }

    .recipe-detail-card__spec {
        display: flex;
        align-items: center;
        margin-right: 16px;
        color: var(--secondary-text);
        font-size: 12px;
        line-height: 20px;
        white-space: nowrap;
        svg {
            @include box(20px);
            margin-right: 4px;
        }
        @include bp($bp-desktop-sm) {
            margin-right: 24px;
            font-size: 14px;
            svg {
                @include box(24px);
                margin-right: 6px;
            }
        }
    }

    .recipe-detail-card__ingredients {
        @include bp($bp-desktop-sm) {
            flex-grow: 1;
            overflow: auto;
            @include scroll-bar(6px, 6px, #a6a6a6, #eeeff4);
        }
    }

    .recipe-detail-card__button {
        width: 100%;
        margin-top: 16px;
        @include bp($bp-desktop-sm) {
            max-width: 280px;
            margin-top: 40px;
        }
    }
</style>
